import React, { useEffect, useState } from 'react';
import { SET_PARAMETERS, PARAMETER_UNIT_IDS } from '../../../common/ENUMS/PARAMETER_ENUM';
import { connect } from "react-redux";
import arrowUp from "../../../common/images/arrow_up.png";
import arrowDown from "../../../common/images/arrow_down.png";
import './V730iSetParameterHistory.scss'



function VentilatorSetParameterHistory(props) {
    const [expanded, setExpanded] = useState(false);

    // incoming API data
    // console.log("props?.currentCursorTimeModePacket in set parameter history------->", props?.currentCursorTimeModePacket)
    let setParameters = props?.currentCursorTimeModePacket?.setParameters || [];
    return (
        <div
            className='vital-footer-container'
            style={{ marginBottom: '0px' , bottom: '0px' ,
                height: (() => {
                    const baseHeight = 12;
                    const rowHeight = 16;
                    const perRow = 7;

                    if (!expanded) return `${baseHeight}%`;

                    const extraRows = Math.ceil(Math.max(setParameters.length - perRow, 0) / perRow);
                    const totalHeight = baseHeight + extraRows * rowHeight;
                    return `${totalHeight}%`;
                })(),
            }}
        >

            <div className='footer-param-box-values'>
                {setParameters.map((item, index) => {
                    const paramId = item?.[0];
                    let paramValue = item?.[1];
                    const paramUnit = item?.[2];

                    // Validate the unit exists in map
                    const hasValidUnit = PARAMETER_UNIT_IDS?.[paramUnit]?.UNIT != null;

                    const formatValue = (num) => {
                        if (num == null || isNaN(num)) return "--";

                        const truncated = num * 100;

                        // integer (34 → 34)
                        if (truncated % 100 === 0) {
                            return num.toString();
                        }
                        // one decimal
                        else if (truncated % 10 === 0) {
                            const numStr = num.toString();
                            const [intPart, decPart] = numStr.split(".");
                            return intPart + "." + (decPart ? decPart[0] : "0");
                        }
                        // two decimals
                        else {
                            const numStr = num.toString();
                            const [intPart, decPart] = numStr.split(".");
                            return intPart + "." + (decPart ? decPart.slice(0, 2) : "00");
                        }
                    };

                    // Special formatting for I:E ratio → paramId = 100506
                    if (hasValidUnit && paramValue !== null && !isNaN(paramValue)) {

                        if (paramId === 100506) {
                            paramValue =
                                paramValue <= 1
                                    ? `1 : ${(1 / parseFloat(paramValue)).toFixed(1)}`
                                    : `${parseFloat(paramValue).toFixed(1)} : 1`;
                        } else {
                            paramValue = formatValue(paramValue);
                        }
                    } else {
                        paramValue = "--";
                    }

                    // Unit text
                    const unit = hasValidUnit
                        ? PARAMETER_UNIT_IDS?.[paramUnit]?.UNIT ?? "-"
                        : "-";

                    // Parameter title
                    const title = SET_PARAMETERS?.[paramId]?.TITLE ?? "-";

                    return (
                        <div className='footer-param-box' key={index}>
                            <div className='footer-param-name'>{title}</div>
                            <div className='footer-param-value'>{paramValue}</div>
                            <div className='footer-param-unit'>{unit}</div>
                        </div>
                    );
                })}
            </div>

            <div className='footer-param-box-arrow' onClick={() => setExpanded(!expanded)}>
                <img
                    src={expanded ? arrowDown : arrowUp}
                    alt={expanded ? 'arrowDown' : 'arrowUp'}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    let ventilatorPatientModeAlarmProfileData = state?.deviceVitalDataReducer?.ventilatorPatientModeAlarmProfileData?.[ownProps.bedId];
    // console.log("ventilatorPatientModeAlarmProfileData in set parameters------->", ventilatorPatientModeAlarmProfileData)

    return {
        ventilatorPatientModeAlarmProfileData: ventilatorPatientModeAlarmProfileData,
        config: state.configReducer.config.bedDetailConfig
    }
}
export default connect(mapStateToProps, null)(VentilatorSetParameterHistory);